/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  IntegrationChainEntity,
} from '../models/index';
import {
    IntegrationChainEntityFromJSON,
    IntegrationChainEntityToJSON,
} from '../models/index';

export interface CreateChainRequest {
    integrationChainEntity: IntegrationChainEntity;
    sessionId?: string;
}

export interface DeleteChainRequest {
    chainId: string;
    sessionId?: string;
}

export interface DisableChainRequest {
    chainId: string;
    sessionId?: string;
}

export interface EnableChainRequest {
    chainId: string;
    sessionId?: string;
}

export interface ExecuteChainRequest {
    chainId: string;
    sessionId?: string;
}

export interface GetChainExecutionRequest {
    chainExecutionId: string;
    sessionId?: string;
}

export interface GetChainExecutionsRequest {
    chainId: string;
    sessionId?: string;
    limit?: number;
}

export interface GetChainsRequest {
    enabledOnly?: boolean;
    sessionId?: string;
}

export interface UpdateChainRequest {
    chainId: string;
    integrationChainEntity: IntegrationChainEntity;
    sessionId?: string;
}

/**
 * IntegrationMarketplaceChainsApi - interface
 * 
 * @export
 * @interface IntegrationMarketplaceChainsApiInterface
 */
export interface IntegrationMarketplaceChainsApiInterface {
    /**
     * Create a new integration chain (workflow composition)
     * @summary Create chain
     * @param {IntegrationChainEntity} integrationChainEntity 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    createChainRaw(requestParameters: CreateChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Create a new integration chain (workflow composition)
     * Create chain
     */
    createChain(requestParameters: CreateChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Delete an integration chain
     * @summary Delete chain
     * @param {string} chainId Chain ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    deleteChainRaw(requestParameters: DeleteChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Delete an integration chain
     * Delete chain
     */
    deleteChain(requestParameters: DeleteChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Disable an integration chain
     * @summary Disable chain
     * @param {string} chainId Chain ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    disableChainRaw(requestParameters: DisableChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Disable an integration chain
     * Disable chain
     */
    disableChain(requestParameters: DisableChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Enable an integration chain
     * @summary Enable chain
     * @param {string} chainId Chain ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    enableChainRaw(requestParameters: EnableChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Enable an integration chain
     * Enable chain
     */
    enableChain(requestParameters: EnableChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Execute an integration chain (triggers Temporal workflow)
     * @summary Execute chain
     * @param {string} chainId Chain ID
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    executeChainRaw(requestParameters: ExecuteChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Execute an integration chain (triggers Temporal workflow)
     * Execute chain
     */
    executeChain(requestParameters: ExecuteChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get one chain run with step executions (which step failed, timing, etc.)
     * @summary Get chain execution
     * @param {string} chainExecutionId 
     * @param {string} [sessionId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    getChainExecutionRaw(requestParameters: GetChainExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get one chain run with step executions (which step failed, timing, etc.)
     * Get chain execution
     */
    getChainExecution(requestParameters: GetChainExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get execution history for a chain (related step executions linked)
     * @summary Get chain executions
     * @param {string} chainId 
     * @param {string} [sessionId] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    getChainExecutionsRaw(requestParameters: GetChainExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get execution history for a chain (related step executions linked)
     * Get chain executions
     */
    getChainExecutions(requestParameters: GetChainExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Get all integration chains for the tenant
     * @summary Get chains
     * @param {boolean} [enabledOnly] Only enabled chains
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    getChainsRaw(requestParameters: GetChainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Get all integration chains for the tenant
     * Get chains
     */
    getChains(requestParameters: GetChainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

    /**
     * Update an existing integration chain
     * @summary Update chain
     * @param {string} chainId Chain ID
     * @param {IntegrationChainEntity} integrationChainEntity 
     * @param {string} [sessionId] Session ID for authorization
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IntegrationMarketplaceChainsApiInterface
     */
    updateChainRaw(requestParameters: UpdateChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>>;

    /**
     * Update an existing integration chain
     * Update chain
     */
    updateChain(requestParameters: UpdateChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }>;

}

/**
 * 
 */
export class IntegrationMarketplaceChainsApi extends runtime.BaseAPI implements IntegrationMarketplaceChainsApiInterface {

    /**
     * Create a new integration chain (workflow composition)
     * Create chain
     */
    async createChainRaw(requestParameters: CreateChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['integrationChainEntity'] == null) {
            throw new runtime.RequiredError(
                'integrationChainEntity',
                'Required parameter "integrationChainEntity" was null or undefined when calling createChain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/chains`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationChainEntityToJSON(requestParameters['integrationChainEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Create a new integration chain (workflow composition)
     * Create chain
     */
    async createChain(requestParameters: CreateChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.createChainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete an integration chain
     * Delete chain
     */
    async deleteChainRaw(requestParameters: DeleteChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainId'] == null) {
            throw new runtime.RequiredError(
                'chainId',
                'Required parameter "chainId" was null or undefined when calling deleteChain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chains/{chainId}`;
        urlPath = urlPath.replace(`{${"chainId"}}`, encodeURIComponent(String(requestParameters['chainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Delete an integration chain
     * Delete chain
     */
    async deleteChain(requestParameters: DeleteChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.deleteChainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Disable an integration chain
     * Disable chain
     */
    async disableChainRaw(requestParameters: DisableChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainId'] == null) {
            throw new runtime.RequiredError(
                'chainId',
                'Required parameter "chainId" was null or undefined when calling disableChain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chains/{chainId}/disable`;
        urlPath = urlPath.replace(`{${"chainId"}}`, encodeURIComponent(String(requestParameters['chainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Disable an integration chain
     * Disable chain
     */
    async disableChain(requestParameters: DisableChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.disableChainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Enable an integration chain
     * Enable chain
     */
    async enableChainRaw(requestParameters: EnableChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainId'] == null) {
            throw new runtime.RequiredError(
                'chainId',
                'Required parameter "chainId" was null or undefined when calling enableChain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chains/{chainId}/enable`;
        urlPath = urlPath.replace(`{${"chainId"}}`, encodeURIComponent(String(requestParameters['chainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Enable an integration chain
     * Enable chain
     */
    async enableChain(requestParameters: EnableChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.enableChainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Execute an integration chain (triggers Temporal workflow)
     * Execute chain
     */
    async executeChainRaw(requestParameters: ExecuteChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainId'] == null) {
            throw new runtime.RequiredError(
                'chainId',
                'Required parameter "chainId" was null or undefined when calling executeChain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chains/{chainId}/execute`;
        urlPath = urlPath.replace(`{${"chainId"}}`, encodeURIComponent(String(requestParameters['chainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Execute an integration chain (triggers Temporal workflow)
     * Execute chain
     */
    async executeChain(requestParameters: ExecuteChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.executeChainRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get one chain run with step executions (which step failed, timing, etc.)
     * Get chain execution
     */
    async getChainExecutionRaw(requestParameters: GetChainExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainExecutionId'] == null) {
            throw new runtime.RequiredError(
                'chainExecutionId',
                'Required parameter "chainExecutionId" was null or undefined when calling getChainExecution().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chains/executions/{chainExecutionId}`;
        urlPath = urlPath.replace(`{${"chainExecutionId"}}`, encodeURIComponent(String(requestParameters['chainExecutionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get one chain run with step executions (which step failed, timing, etc.)
     * Get chain execution
     */
    async getChainExecution(requestParameters: GetChainExecutionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getChainExecutionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get execution history for a chain (related step executions linked)
     * Get chain executions
     */
    async getChainExecutionsRaw(requestParameters: GetChainExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainId'] == null) {
            throw new runtime.RequiredError(
                'chainId',
                'Required parameter "chainId" was null or undefined when calling getChainExecutions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chains/{chainId}/executions`;
        urlPath = urlPath.replace(`{${"chainId"}}`, encodeURIComponent(String(requestParameters['chainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get execution history for a chain (related step executions linked)
     * Get chain executions
     */
    async getChainExecutions(requestParameters: GetChainExecutionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getChainExecutionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get all integration chains for the tenant
     * Get chains
     */
    async getChainsRaw(requestParameters: GetChainsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        const queryParameters: any = {};

        if (requestParameters['enabledOnly'] != null) {
            queryParameters['enabledOnly'] = requestParameters['enabledOnly'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/marketplace/chains`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all integration chains for the tenant
     * Get chains
     */
    async getChains(requestParameters: GetChainsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.getChainsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an existing integration chain
     * Update chain
     */
    async updateChainRaw(requestParameters: UpdateChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: any; }>> {
        if (requestParameters['chainId'] == null) {
            throw new runtime.RequiredError(
                'chainId',
                'Required parameter "chainId" was null or undefined when calling updateChain().'
            );
        }

        if (requestParameters['integrationChainEntity'] == null) {
            throw new runtime.RequiredError(
                'integrationChainEntity',
                'Required parameter "integrationChainEntity" was null or undefined when calling updateChain().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/marketplace/chains/{chainId}`;
        urlPath = urlPath.replace(`{${"chainId"}}`, encodeURIComponent(String(requestParameters['chainId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IntegrationChainEntityToJSON(requestParameters['integrationChainEntity']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Update an existing integration chain
     * Update chain
     */
    async updateChain(requestParameters: UpdateChainRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: any; }> {
        const response = await this.updateChainRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
